export const getPlayerId = (player) => {
  if (!player) return '';
  if (typeof player === 'string' || typeof player === 'number') return String(player);
  if (typeof player !== 'object') return '';

  const candidate = player._id || player.id || player.playerId || player.value || player.$oid;
  if (candidate && candidate !== player) return getPlayerId(candidate);

  const stringValue = player.toString?.();
  return stringValue && stringValue !== '[object Object]' ? String(stringValue) : '';
};

export const getManualTeamPlayerOptions = (allPlayers = [], team1Players = [], team2Players = []) => {
  const selectedTeam1Ids = new Set(team1Players.map(getPlayerId).filter(Boolean));
  const selectedTeam2Ids = new Set(team2Players.map(getPlayerId).filter(Boolean));

  const team1Options = allPlayers.filter((player) => {
    const id = getPlayerId(player);
    return Boolean(id) && (!selectedTeam2Ids.has(id) || selectedTeam1Ids.has(id));
  });
  const team2Options = allPlayers.filter((player) => {
    const id = getPlayerId(player);
    return Boolean(id) && (!selectedTeam1Ids.has(id) || selectedTeam2Ids.has(id));
  });

  return { selectedTeam1Ids, selectedTeam2Ids, team1Options, team2Options };
};
